export default __webpack_public_path__ + "static/media/appointment.de728d64.svg";